import React, { PureComponent } from 'react';
import ConsoleTile from 'components/shared/ConsoleTile/ConsoleTile';
import styles from './ParametersView.module.css';
import { connect } from 'react-redux';
import ParametersTable from 'components/features/ParametersView/ParametersTable/ParametersTable';
import ParametersGraph from 'components/features/ParametersView/ParametersGraph/ParametersGraph';

class ParametersView extends PureComponent {
  componentDidMount() {
    //fetch the trimmed devices from the table
    // this.props.dispatch(
    //   searchComponentFilteredDevicesV2(
    //     'parametersTable',
    //     defaultParametersTableSearchBody,
    //     null,
    //     this.props.filterDictionary
    //   )
    // );

    // //fetch aggregates for grpah and pass it in
    // this.props.dispatch(
    //   searchComponentFilteredDevicesV2(
    //     'parametersGraph',
    //     defaultParametersGraphSearchBody,
    //     'v1',
    //     this.props.filterDictionary
    //   )
    // );
  }

  render() {
    let tileHeader = (
      <div className="tileHeaderContainer">
        <span className={styles.headerTitle}>{'Parameters'}</span>
      </div>
    );

    return (
      <div className={styles.parametersViewContainer}>
        <ConsoleTile tileHeader={tileHeader}>
          <div className={styles.parametersContent}>
            <div className={styles.parametersTableDiv}>
              <ParametersTable />
            </div>
            <div className={styles.parametersGraphDiv}>
              <ParametersGraph />
            </div>
          </div>
        </ConsoleTile>
      </div>
    );
  }
}

export default connect((store) => {
  return {
    filterDictionary: store.data.filterDictionary
  };
})(ParametersView);
